"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNotificationsTaskDeclined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.597 19a1 1 0 00-.812.416l-3.917 5.432a3 3 0 01-2.431 1.245l-17.347.013a3 3 0 00-2.998 3v62.893a3 3 0 003 3H91a3 3 0 003-3V29.11a3 3 0 00-3-3H73.514a3 3 0 01-2.433-1.246l-3.919-5.433a1 1 0 00-.81-.415l-13.755-.014zm-2.434-.754A3 3 0 0152.6 17l13.754.014a3 3 0 012.43 1.245l3.919 5.434a1 1 0 00.811.415h17.487a5 5 0 015 5v62.89a5 5 0 01-5 5H28.09a5 5 0 01-5-5V29.106a5 5 0 014.997-5l17.347-.013a1 1 0 00.81-.415l3.918-5.432z",
    fill: "#BA2D25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5 70V40h2v30h-2z",
    fill: "#BA2D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 76.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#BA2D25"
  }));
}

var _default = SvgNotificationsTaskDeclined;
exports["default"] = _default;